<template>
  <div>
    <h2 v-html="$t(`${namespace}.title`)" class="login__title" />
    <p class="subtitle login__text">{{ $t(`${namespace}.resume.title`) }}</p>

    <div class="preview">
      <ul class="preview__list">
        <li class="preview__list__item">
          <span>{{ $t('Common.name') }}</span>
          <p>
            <span v-if="data && data.name">{{ data.name }}</span>
            <span v-else>{{ $t('Common.uninformed') }}</span>
          </p>
        </li>

        <li class="preview__list__item">
          <span>{{ $t('Common.company') }}</span>
          <p>
            <span v-if="data && data.companyName">{{ data.companyName }}</span>
            <span v-else>{{ $t('Common.uninformed') }}</span>
          </p>
        </li>

        <li class="preview__list__item">
          <span>{{ $t('Common.phone') }}</span>
          <p>
            <span v-if="data && data.phoneNumber">{{ data.phoneNumber | phone }}</span>
            <span v-else>{{ $t('Common.uninformed') }}</span>
          </p>
        </li>

        <li class="preview__list__item">
          <span>{{ $t('Common.cpf') }}</span>
          <p>
            <span v-if="data && data.document">{{ data.document | formatCPF }}</span>
            <span v-else>{{ $t('Common.uninformed') }}</span>
          </p>
        </li>
      </ul>
    </div>

    <p class="subtitle login__text">{{ $t(`${namespace}.subtitle`) }}</p>
    <p class="login__text">{{ $t(`${namespace}.text`) }}</p>

    <Button
      color="secondary"
      gradient
      block
      :disabled="submitted"
      :loading="submitted"
      large
      @click="handleClick"
    >
      {{ $t(`${namespace}.buttonLabel`) }}
    </Button>
  </div>
</template>

<script>
import { createHideLink } from 'corp-front-vue-commons/src/utils/functions'

export default {
  name: 'Success',
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.FirstAccessPage.success',
      youTubeLink: 'https://www.youtube.com/watch?v=g99phzUi3kY'
    }
  },
  methods: {
    redirectToLogin () {
      this.$router.push({ name: 'Login' }).catch(e => {})
    },

    handleClick () {
      createHideLink(this.youTubeLink, '_blank')
      this.redirectToLogin()
    }
  }
}
</script>

<style lang="scss" scoped>
.subtitle {
  color: var(--gray-7);
  font-family: $title-font;
  font-size: $base-font-size;
  font-weight: 600;
  margin: 0;
  padding: 15px 0 10px;
}

.preview {
  background-color: $gray-1;
  border: 1px solid $gray-2;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 24px;
}

.preview__list {
  list-style-type: none;
  padding: 0;
}

.preview__list__item {

  + .preview__list__item {
    margin-top: 16px;
  }

  > span {
    color: $gray-6;
    display: block;
    font-size: $base-font-size - 1px;
  }

  p {
    color: var(--gray-7);
    margin: 0;
  }
}
</style>
